import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Colors } from 'modules/theme';
import Footer from '../../components/Footer';

const steps = [
  'Open the YieldBucks app on your device.',
  'Tap the Profile icon at the bottom of the screen.',
  'Scroll down and tap "Delete Account".',
  'Confirm your choice when prompted.',
];

export default class DeleteAccountContainer extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Container style={{ minHeight: 'calc(100vh - 221px)' }} className="mt-5 pb-5">
          <Row className="justify-content-center">
            <Col xs={12} md={8} lg={6}>
              <Container fluid className="mt-5">
                <Row>
                  <h1 style={{ color: Colors.blueButton, fontSize: 30 }}>Delete Your Account</h1>
                </Row>

                <Row className="mt-4">
                  <p style={{ color: Colors.white, fontSize: 16, lineHeight: 1.7 }}>
                    You can permanently delete your YieldBucks account and all associated data
                    directly from within the app. This action is irreversible — your profile,
                    rewards balance, and transaction history will be removed.
                  </p>
                </Row>

                <Row className="mt-4">
                  <h4 style={{ color: Colors.yellowExtra }}>
                    How to delete your account in the app
                  </h4>
                </Row>

                {steps.map((step, i) => (
                  <Row key={i} className="mt-3 align-items-start" style={{ flexWrap: 'nowrap' }}>
                    <div
                      style={{
                        width: 32,
                        height: 32,
                        borderRadius: 16,
                        backgroundColor: Colors.blueButton,
                        color: Colors.white,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 'bold',
                        flexShrink: 0,
                        marginRight: 16,
                        marginLeft: 15,
                      }}
                    >
                      {i + 1}
                    </div>
                    <p style={{ color: Colors.white, fontSize: 16, margin: 0, lineHeight: 1.7 }}>
                      {step}
                    </p>
                  </Row>
                ))}

                <Row className="mt-5">
                  <div
                    style={{
                      backgroundColor: '#2B2930',
                      borderRadius: 12,
                      padding: 24,
                      width: '100%',
                    }}
                  >
                    <h5 style={{ color: Colors.yellowExtra, marginBottom: 8 }}>
                      Don't have access to the app?
                    </h5>
                    <p style={{ color: Colors.white, fontSize: 15, marginBottom: 16 }}>
                      If you are unable to access the app and would like your account deleted,
                      contact our support team and we will process your request within 30 days.
                    </p>
                    <a href="mailto:contact@yieldbucks.com" style={{ textDecoration: 'none' }}>
                      <span
                        style={{
                          color: Colors.blueButton,
                          fontWeight: 'bold',
                          fontSize: 16,
                          textDecoration: 'underline',
                        }}
                      >
                        contact@yieldbucks.com
                      </span>
                    </a>
                  </div>
                </Row>
              </Container>
            </Col>
          </Row>
        </Container>
        <Footer />
      </>
    );
  }
}
